export async function probeApiHealth(baseUrl: string, timeoutMs = 4000): Promise<boolean> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetch(`${baseUrl}/core/health/`, { signal: controller.signal, mode: "cors" });
    return response.ok;
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
}
